import { CANVAS_SNAP, snapToGrid } from "../canvas-controls.config";

/** Diagonal cascade offsets from a cursor anchor in flow space. */
export function createCascadePlacementState(
  flowPosition: { x: number; y: number },
  clientX: number,
) {
  const [snapX, snapY] = CANVAS_SNAP.grid;
  const cascadeX = clientX > window.innerWidth / 2 ? -snapX * 2 : snapX * 2;
  let index = 0;

  const snapCursor = () => ({
    x: snapToGrid(flowPosition.x, snapX),
    y: snapToGrid(flowPosition.y, snapY),
  });

  return {
    snapCursor,
    next: () => {
      const base = snapCursor();
      const i = index++;
      return {
        x: base.x + i * cascadeX,
        y: base.y + i * snapY * 2,
      };
    },
    reset: () => {
      index = 0;
    },
  };
}
